(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ---------- Après navigation ---------- */
  if (!customElements.get('apres-nav')) {
    class ApresNav extends HTMLElement {
      connectedCallback() {
        this.triggers = [...this.querySelectorAll('[data-apn-trigger]')];
        this.panels = [...this.querySelectorAll('[data-apn-panel]')];
        this.backdrop = this.querySelector('[data-apn-backdrop]');
        this.drawer = this.querySelector('[data-apn-drawer]');
        this.openBtn = this.querySelector('[data-apn-open]');
        this.current = null;
        this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        this.triggers.forEach((btn) => {
          const key = btn.dataset.apnTrigger;
          btn.addEventListener('click', () => (this.current === key ? this.closeAll() : this.open(key)));
          if (this.canHover) {
            btn.addEventListener('mouseenter', () => { clearTimeout(this.t); this.t = setTimeout(() => this.open(key), 70); });
          }
        });
        if (this.canHover) {
          const bar = this.querySelector('.apn-bar');
          const keep = () => clearTimeout(this.t);
          const leave = () => { clearTimeout(this.t); this.t = setTimeout(() => this.closeAll(), 180); };
          this.panels.forEach((p) => { p.addEventListener('mouseenter', keep); p.addEventListener('mouseleave', leave); });
          bar.addEventListener('mouseleave', leave);
          this.querySelectorAll('.apn-logo, .apn-right').forEach((el) => el.addEventListener('mouseenter', leave));
        }
        this.backdrop && this.backdrop.addEventListener('click', () => this.closeAll());
        document.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          if (this.drawer && this.drawer.classList.contains('is-open')) this.closeDrawer();
          else if (this.current) { const b = this.querySelector(`[data-apn-trigger="${this.current}"]`); this.closeAll(); b && b.focus(); }
        });
        document.addEventListener('click', (e) => { if (this.current && !this.contains(e.target)) this.closeAll(); });

        /* Mobile menu */
        this.openBtn && this.openBtn.addEventListener('click', () => this.openDrawer());
        this.querySelectorAll('[data-apn-close]').forEach((b) => b.addEventListener('click', () => this.closeDrawer()));
        this.querySelectorAll('[data-apn-acc]').forEach((row) => {
          row.addEventListener('click', () => {
            const wasOpen = row.getAttribute('aria-expanded') === 'true';
            this.querySelectorAll('[data-apn-acc]').forEach((r) => {
              r.setAttribute('aria-expanded', 'false');
              const s = document.getElementById(r.getAttribute('aria-controls')); if (s) s.hidden = true;
            });
            if (!wasOpen) {
              row.setAttribute('aria-expanded', 'true');
              const s = document.getElementById(row.getAttribute('aria-controls')); if (s) s.hidden = false;
            }
          });
        });
        window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => { if (e.matches) this.closeDrawer(); else this.closeAll(); });

        /* Custom order: open your existing popup if it's on the page */
        this.querySelectorAll('[data-apn-custom]').forEach((a) => {
          a.addEventListener('click', (e) => {
            const popup = document.querySelector('.customOrder_popup');
            if (!popup) return;
            e.preventDefault();
            this.closeAll(); this.closeDrawer();
            popup.classList.add('active');
            document.documentElement.style.overflow = 'hidden';
          });
        });
      }
      open(key) {
        this.current = key;
        this.triggers.forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.apnTrigger === key)));
        this.panels.forEach((p) => p.classList.toggle('is-open', p.dataset.apnPanel === key));
        this.classList.add('is-open');
      }
      closeAll() {
        this.current = null;
        this.triggers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
        this.panels.forEach((p) => p.classList.remove('is-open'));
        this.classList.remove('is-open');
      }
      openDrawer() {
        if (!this.drawer) return;
        this.drawer.classList.add('is-open');
        this.openBtn && this.openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('apn-lock');
        const c = this.drawer.querySelector('[data-apn-close]'); c && setTimeout(() => c.focus(), 50);
      }
      closeDrawer() {
        if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
        this.drawer.classList.remove('is-open');
        this.openBtn && this.openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('apn-lock');
        this.openBtn && this.openBtn.focus();
      }
    }
    customElements.define('apres-nav', ApresNav);
  }

  /* ---------- Sticky header (from your original theme) ---------- */
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
        if (this.headerIsAlwaysSticky && this.header) this.header.classList.add('shopify-section-header-sticky');
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
      setHeaderHeight() { if (this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }
      createObserver() {
        const observer = new IntersectionObserver((entries, obs) => { this.headerBounds = entries[0].intersectionRect; obs.disconnect(); });
        if (this.header) observer.observe(this.header);
      }
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (!this.header || document.documentElement.classList.contains('apn-lock')) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
          else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
      }
      hide() {
        const nav = this.querySelector('apres-nav'); nav && nav.closeAll && nav.closeAll();
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      reveal() {
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }
      reset() {
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(function () {
  const root = document.querySelector('[data-apc]');
  if (!root) return;
  const cards = [...root.querySelectorAll('.apc-card')];
  const craves = [...root.querySelectorAll('[data-apc-crave]')];
  const count = root.querySelector('[data-apc-count]');
  const clear = root.querySelector('[data-apc-clear]');
  const empty = root.querySelector('[data-apc-empty]');
  const toast = root.querySelector('[data-apc-toast]');

  function apply(key, label) {
    let n = 0;
    cards.forEach((c) => {
      const show = !key || (' ' + c.dataset.crave + ' ').includes(' ' + key + ' ');
      c.hidden = !show; if (show) n++;
    });
    craves.forEach((b) => b.setAttribute('aria-pressed', String((b.dataset.apcCrave || '') === (key || ''))));
    if (count) count.textContent = n + (n === 1 ? ' item' : ' items');
    if (clear) { clear.hidden = !key; clear.textContent = (label || '') + ' ✕'; }
    if (empty) empty.hidden = n !== 0;
  }
  craves.forEach((b) => b.addEventListener('click', () => apply(b.dataset.apcCrave, b.dataset.apcLabel)));
  clear && clear.addEventListener('click', () => apply('', ''));
  const c2 = root.querySelector('[data-apc-clear-2]'); c2 && c2.addEventListener('click', () => apply('', ''));

  let tt;
  function say(msg) { if (!toast) return; toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => toast.classList.remove('is-on'), 2400); }

  root.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-apc-add]');
    if (!btn) return;
    btn.classList.add('is-loading');
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: Number(btn.dataset.apcAdd), quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    try {
      const addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      const res = await fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const json = await res.json();
      if (json.status) { say(json.description || 'Sorry, that one is sold out.'); return; }
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        const item = (json.items && json.items[0]) || json;
        drawer.renderContents({ ...item, id: item.id || item.variant_id, sections: json.sections });
      } else {
        say(btn.dataset.apcName + ' added to cart ✓');
      }
    } catch (err) {
      say('Something went wrong. Please try again.');
    } finally {
      btn.classList.remove('is-loading');
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
